import { api } from '../base';
import { 
  AuthUserSchema, 
  LoginResponseSchema, 
  SessionCheckSchema,
  type AuthUser,
  type LoginResponse,
  type SessionCheck 
} from '../types';

export class AuthApi {
  async login(email: string, password: string): Promise<LoginResponse> {
    const response = await api.post('/auth/login', { email, password });
    const parsed = LoginResponseSchema.parse(response);
    
    // Set CSRF token for subsequent requests
    api.setCsrfToken(parsed.csrf_token);
    
    return parsed;
  }

  async logout(): Promise<void> {
    await api.post('/auth/logout');
    // Clear CSRF token
    api.setCsrfToken('');
  }

  async getCurrentUser(): Promise<AuthUser> {
    const response = await api.get('/auth/me');
    return AuthUserSchema.parse(response);
  }

  async checkSession(): Promise<SessionCheck> {
    const response = await api.get('/auth/session');
    return SessionCheckSchema.parse(response);
  }

  async uploadAvatar(file: File): Promise<{ avatar_url: string; message: string }> {
    if (!file.type.startsWith('image/')) {
      throw new Error('Please select an image file (JPG, PNG, GIF)');
    }
    
    if (file.size > 5 * 1024 * 1024) { // 5MB limit
      throw new Error('Image must be smaller than 5MB');
    }

    const formData = new FormData();
    formData.append('avatar', file);

    return api.upload('/auth/avatar/upload', formData);
  }

  async deleteAvatar(): Promise<void> {
    await api.delete('/auth/avatar');
  }
}